import React from 'react';
import './ListaPreguntasGrupo.css';
import GeneradorFormulario from './GeneradorFormulario';

const ListaPreguntasGrupo = ({
  grupoSeleccionado,
  datosFormulario,
  rutaNavegacion = [],
  respuestasFormulario = {},
  onRespuestasChange = () => {},
  onCambioRespuesta = () => {},
  preguntasProcesadas = [],
  preguntaSeleccionada = null
}) => {
  // Función para obtener el título del último elemento de la ruta
  const obtenerTituloRuta = () => {
    if (!rutaNavegacion || rutaNavegacion.length === 0) {
      return 'Formulario';
    }
    
    const ultimoElemento = rutaNavegacion[rutaNavegacion.length - 1];
    return ultimoElemento.title || ultimoElemento.name || 'Sin título';
  };

  // Obtener preguntas del grupo seleccionado desde preguntasProcesadas
  const preguntas = preguntasProcesadas || [];

  // Si no hay grupo seleccionado, mostrar mensaje de bienvenida
  if (!grupoSeleccionado) {
    return (
      <div className="form-master-lista-preguntas">
        <div className="form-master-bienvenida">
          <div className="form-master-bienvenida-contenido">
            <div className="form-master-bienvenida-icono">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
                style={{ height: '3rem', width: '3rem' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <p>
              Selecciona un grupo del menú lateral para comenzar a trabajar con las preguntas.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="form-master-lista-preguntas">
      {/* Header con información del grupo */}
      {/* Contenido de preguntas */}
      <div className="form-master-preguntas-content">
        {preguntas.length === 0 ? (
          <div className="form-master-sin-preguntas">
            <div className="form-master-sin-preguntas-icono">
              <svg
                className="mx-auto h-8 w-8 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
                style={{ height: '2rem', width: '2rem' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <p>Este grupo no tiene preguntas asignadas</p>
          </div>
        ) : (
          /* Reemplazar la lista estática con GeneradorFormulario */
          <GeneradorFormulario
            elementoSeleccionado={grupoSeleccionado}
            onCambioRespuesta={onCambioRespuesta}
            respuestas={respuestasFormulario}
            datosFormulario={datosFormulario}
            modoVisualizacion="debug" // // 'formulario' | 'preview' | 'readonly' | 'debug'
            className="form-master-formulario-integrado"
            preguntaSeleccionada={preguntaSeleccionada}
          />
        )}
      </div>
    </div>
  );
};

export default ListaPreguntasGrupo;